/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { baseRequest } from './baseRequest';
import { handleAxiosRequest } from './requestHelper';
const baseRoute = '/api/internal/groups';
export const createTeam = async createBody => handleAxiosRequest(baseRequest.post(baseRoute, createBody));
export const editTeamInfo = async (groupId, teamInfoBody) => handleAxiosRequest(baseRequest.patch(`${baseRoute}/${groupId}`, teamInfoBody));
export const addTeamMembers = async (groupId, assignmentsBody) => handleAxiosRequest(baseRequest.post(`${baseRoute}/${groupId}/assignments`, assignmentsBody));
export const respondToInvite = async (assignmentId, responseBody) => handleAxiosRequest(baseRequest.post(`${baseRoute}/assignments/${assignmentId}/invite-response`, responseBody));
export const deleteTeam = async groupId => handleAxiosRequest(baseRequest.delete(`${baseRoute}/${groupId}`));
export const removeTeamMember = async (groupId, principalId) => handleAxiosRequest(baseRequest.delete(`${baseRoute}/${groupId}/assignments`, {
  params: {
    principalIds: [principalId]
  }
}));
export const patchTeamMembers = async (groupId, patchAssignments) => handleAxiosRequest(baseRequest.patch(`${baseRoute}/${groupId}/assignments`, {
  assignments: patchAssignments
}));